// Author YuJiaBei
// Date 2021-01-05 11:16:47

class EmLcSdSelectionDemSde {
constructor({
        id = null,
        workOrderCode = '',
        status = '',
        sdeIdSte = '',
        sdeIdDept = '',
        sdeIdDeptName = '',
        sdeInitiator = '',
        sdeInitiatorLoginName = '',
        sdeCodeBda = '',
        sdeEquipmentName = '',
        sdeCodeLoc = '',
        sdePurpose = '',
        sdeKeyRequirements = '',
        sdeMinorRequirements = '',
        sdeQuantity = '',
        sdeAttachment = '',
        sdeDescription = '',
        sdeAttachmentList = ''}
= {}) {
    this.id = id;
    this.workOrderCode = workOrderCode;
    this.status = status;
    this.sdeIdSte = sdeIdSte;
    this.sdeIdDept = sdeIdDept;
    this.sdeIdDeptName = sdeIdDeptName;
    this.sdeInitiator = sdeInitiator;
    this.sdeInitiatorLoginName = sdeInitiatorLoginName;
    this.sdeCodeBda = sdeCodeBda;
    this.sdeEquipmentName = sdeEquipmentName;
    this.sdeCodeLoc = sdeCodeLoc;
    this.sdePurpose = sdePurpose;
    this.sdeKeyRequirements = sdeKeyRequirements;
    this.sdeMinorRequirements = sdeMinorRequirements;
    this.sdeQuantity = sdeQuantity;
    this.sdeAttachment = sdeAttachment;
    this.sdeDescription = sdeDescription;
    this.sdeAttachmentList = sdeAttachmentList;
}
}

function newEntity() {
return new EmLcSdSelectionDemSde();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'workOrderCode',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.status',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdeIdSte',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.sdeIdSte',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdeIdDept',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.sdeIdDept',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdeInitiatorLoginName',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.sdeInitiatorLoginName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdeCodeBda',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.sdeCodeBda',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchBdaName',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.emArchBdaName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdeEquipmentName',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.sdeEquipmentName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdeCodeLoc',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.sdeCodeLoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchLocName',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.emArchLocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdePurpose',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.sdePurpose',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdeKeyRequirements',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.sdeKeyRequirements',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdeMinorRequirements',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.sdeMinorRequirements',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdeQuantity',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.sdeQuantity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdeAttachmentList',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.sdeAttachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'sdeDescription',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.sdeDescription',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'statusName',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.statusName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emAclDeptName',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.grid.emAclDeptName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    workOrderCodeFilter : "",
    statusFilter : "",
    sdeIdSteFilter : "",
    sdeIdDeptFilter : "",
    sdeInitiatorFilter : "",
    sdeInitiatorLoginNameFilter : "",
    sdeCodeBdaFilter : "",
    sdeEquipmentNameFilter : "",
    sdeCodeLocFilter : "",
    sdePurposeFilter : "",
    sdeKeyRequirementsFilter : "",
    sdeMinorRequirementsFilter : "",
    sdeQuantityFilter : "",
    workflowQueryTypeFilter : "",
    emAclDeptIdFilter : "",
    emAclDeptNameFilter : "",
    emAclDeptNodeCodeFilter : "",
    emAclDeptNodeCodeNameFilter : "",
    emArchLocCodeFilter : "",
    emArchLocNodeCodeFilter : "",
    emArchLocNodeCodeNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'workOrderCodeFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'EmLcSdSelectionDemSde',statusFilter:1}
        }
        },
        {
        key: 'sdeIdSteFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.sdeIdSte',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'sdeInitiatorLoginNameFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.sdeInitiatorLoginName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"sdeInitiator":"id"}'
                }
        },
        {
        key: 'sdeCodeBdaFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.sdeCodeBda',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'sdeEquipmentNameFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.sdeEquipmentName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdePurposeFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.sdePurpose',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdeKeyRequirementsFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.sdeKeyRequirements',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdeMinorRequirementsFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.sdeMinorRequirements',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdeQuantityFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.sdeQuantity',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'emAclDeptNameFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.emAclDeptName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
                }
        },
        {
        key: 'emAclDeptNodeCodeNameFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.emAclDeptNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptNodeCode":"nodeCode"}'
                }
        },
        {
        key: 'emArchLocCodeFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.emArchLocCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emArchLocNodeCodeNameFilter',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.filter.emArchLocNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emArchLocNodeCode":"nodeCode"}'
                }
        }
];


    const task2EntityConfigs = [
        {
        key: 'sdeInitiatorLoginName',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeInitiatorLoginName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"sdeInitiator":"id"}'
                }
        },
        {
        key: 'sdeEquipmentName',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeEquipmentName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdePurpose',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdePurpose',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]
    const entityFormConfigs = [
        {
        key: 'sdeIdSte',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeIdSte',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'sdeIdDeptName',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeIdDeptName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"sdeIdDept":"id"}'
                }
        },
        {
        key: 'sdeInitiatorLoginName',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeInitiatorLoginName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"sdeInitiator":"id"}'
                }
        },
        {
        key: 'sdeCodeBda',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeCodeBda',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'sdeEquipmentName',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeEquipmentName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdeCodeLoc',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeCodeLoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'sdePurpose',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdePurpose',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdeKeyRequirements',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeKeyRequirements',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'sdeMinorRequirements',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeMinorRequirements',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdeQuantity',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeQuantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'sdeDescription',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'sdeAttachmentList',
        label: 'label.em.lifecycle.emLcSdSelectionDemSde.entity.sdeAttachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'sdeAttachment'
                }
        }
]

export {EmLcSdSelectionDemSde, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs
, task2EntityConfigs

}
